import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const playbackRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "emergency-calls/playback/$callId",
}).lazy(() => import("./Playback.lazy").then((d) => d.Route));
